import styles from 'styles/components/common/lists/DualHeaderTable.module.scss';
import { TEvaluationChartCountInfo } from 'types/apis/professor';

type TProps = {
  width?: string;
  colHeight?: string;
  dataHeight?: string;
  fontSize?: string;
  studentCount: number;
  finishCount: TEvaluationChartCountInfo[];
};

const SecondDualHeaderTable = ({
  width,
  colHeight,
  dataHeight,
  fontSize,
  studentCount,
  finishCount,
}: TProps) => {
  return (
    <div className="dual_table">
      <table>
        <thead>
          <tr className={styles.tr}>
            <th
              className={styles.table_column}
              style={{ width: width, height: colHeight, fontSize: fontSize }}
            >
              치주검사
            </th>
            <th
              className={styles.table_column}
              style={{ width: width, height: colHeight, fontSize: fontSize }}
            >
              구강사진(DSLR)
            </th>
            <th
              className={styles.table_column}
              style={{ width: width, height: colHeight, fontSize: fontSize }}
            >
              구강사진
            </th>
            <th
              className={styles.table_column}
              style={{ width: width, height: colHeight, fontSize: fontSize }}
            >
              치면세균막검사
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className={styles.tr}>
            <th
              className={styles.table_data}
              style={{ width, height: dataHeight, fontSize }}
            >
              {(() => {
                const evaluatedCount = finishCount?.find(
                  (count) => count.chartTypeName === '치주검사'
                )?.chartEvaluatedCount;

                return !evaluatedCount || evaluatedCount === '-'
                  ? '-'
                  : `${evaluatedCount} / ${studentCount}`;
              })()}
            </th>
            <th
              className={styles.table_data}
              style={{ width, height: dataHeight, fontSize }}
            >
              {(() => {
                const evaluatedCount = finishCount?.find(
                  (count) => count.chartTypeName === '구강사진(DSLR)'
                )?.chartEvaluatedCount;

                return !evaluatedCount || evaluatedCount === '-'
                  ? '-'
                  : `${evaluatedCount} / ${studentCount}`;
              })()}
            </th>
            <th
              className={styles.table_data}
              style={{ width, height: dataHeight, fontSize }}
            >
              {(() => {
                const evaluatedCount = finishCount?.find(
                  (count) => count.chartTypeName === '구강사진'
                )?.chartEvaluatedCount;

                return !evaluatedCount || evaluatedCount === '-'
                  ? '-'
                  : `${evaluatedCount} / ${studentCount}`;
              })()}
            </th>
            <th
              className={styles.table_data}
              style={{ width, height: dataHeight, fontSize }}
            >
              {(() => {
                const evaluatedCount = finishCount?.find(
                  (count) => count.chartTypeName === '치면세균막검사'
                )?.chartEvaluatedCount;

                return !evaluatedCount || evaluatedCount === '-'
                  ? '-'
                  : `${evaluatedCount} / ${studentCount}`;
              })()}
            </th>
          </tr>
        </tbody>
      </table>
      <table>
        <thead>
          <tr className={styles.tr}>
            <th
              className={styles.table_column}
              style={{ width: width, height: colHeight, fontSize: fontSize }}
            >
              진단모델
            </th>
            <th
              className={styles.table_column}
              style={{ width: width, height: colHeight, fontSize: fontSize }}
            >
              치위생수행
            </th>
            <th
              className={styles.table_column}
              style={{ width: width, height: colHeight, fontSize: fontSize }}
            >
              치위생진단·계획·평가
            </th>
            <th
              className={styles.table_column}
              style={{ width: width, height: colHeight, fontSize: fontSize }}
            >
              구강보건교육
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className={styles.tr}>
            <th
              className={styles.table_data}
              style={{ width, height: dataHeight, fontSize }}
            >
              {(() => {
                const evaluatedCount = finishCount?.find(
                  (count) => count.chartTypeName === '진단모델'
                )?.chartEvaluatedCount;

                return !evaluatedCount || evaluatedCount === '-'
                  ? '-'
                  : `${evaluatedCount} / ${studentCount}`;
              })()}
            </th>
            <th
              className={styles.table_data}
              style={{ width, height: dataHeight, fontSize }}
            >
              {(() => {
                const evaluatedCount = finishCount?.find(
                  (count) => count.chartTypeName === '치위생수행'
                )?.chartEvaluatedCount;

                return !evaluatedCount || evaluatedCount === '-'
                  ? '-'
                  : `${evaluatedCount} / ${studentCount}`;
              })()}
            </th>
            <th
              className={styles.table_data}
              style={{ width, height: dataHeight, fontSize }}
            >
              {(() => {
                const evaluatedCount = finishCount?.find(
                  (count) => count.chartTypeName === '치위생진단·계획·평가'
                )?.chartEvaluatedCount;

                return !evaluatedCount || evaluatedCount === '-'
                  ? '-'
                  : `${evaluatedCount} / ${studentCount}`;
              })()}
            </th>
            <th
              className={styles.table_data}
              style={{ width, height: dataHeight, fontSize }}
            >
              {(() => {
                const evaluatedCount = finishCount?.find(
                  (count) => count.chartTypeName === '구강보건교육'
                )?.chartEvaluatedCount;

                return !evaluatedCount || evaluatedCount === '-'
                  ? '-'
                  : `${evaluatedCount} / ${studentCount}`;
              })()}
            </th>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SecondDualHeaderTable;
